import { HistoricalErpSynchronization } from '../historical-erp-synchronization';

export class HistoricalErpSynchronizationBuilder {
  static fromJson(json) {
    return (json)
      ? new HistoricalErpSynchronization(
        json.hash,
        json.startTime,
        json.endTime,
        json.success,
        json.synchronizationLimit
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/historical-erp-synchronization.builder.ts